export const REFRESH_TASKS = 'REFRESH_TASKS';
export const ADD_TASK = 'ADD_TASK';
export const UPDATE_TASK = 'UPDATE_TASK';
export const DELETE_TASK = 'DELETE_TASK';
export const SET_SELECTED_TASK = 'SET_SELECTED_TASK';